import * as applicationConfig from "../config";
import Icon from "Core/components/display/Icon";
import {rtrimChar} from "Core/helpers/string";
import {icon_font_symbol_class_prefix} from "Config/app";
import {AclCheckDataObject} from "Core/acl";
import {getArray} from "Core/helpers/data";
import {CURRENT_USER_TYPE} from "../../../../helpers/currentUser/const";

/**
 * Rendered icon element used as a page icon
 * @description Page icons can be used in main navigation, page links and buttons or any other place.
 * @type {JSX.Element}
 */
export const iconElement = <Icon symbol="file-exe" symbolPrefix={`${'icofont-' ? 'icofont-' : icon_font_symbol_class_prefix}`} />

/**
 * Access control settings
 * @type {AclCheckDataObject}
 */
export const access = new AclCheckDataObject(
	[...getArray(applicationConfig, 'access.permissions'), ],
	[...getArray(applicationConfig, 'access.userTypes'), CURRENT_USER_TYPE.SUPER_ADMIN],
	false
);

/**
 * Page router path relative to the base path of the app
 * @note Use '/' at the beginning (for example '/home').
 * @type {string}
 */
export const routerPath = `${rtrimChar(applicationConfig.routerPath, '/')}/appLibraries/list`;

/**
 * Page translation path
 * @type {string}
 */
export const translationPath = `${applicationConfig.translationPath}.LibrariesPage`;